import { IDates } from '../../utils/sharedInterfaces'

export const updateDates = (dates: IDates) => ({
  type: 'update_dates',
  dates
})
